import React from 'react';
/**
 * @description LibraryAware's /folders/ context.
 */
const AppContext = React.createContext();
export default AppContext